'use client'

import { Bot, LayoutDashboard, MessageSquare, User, Users } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { MenuKey } from '@/lib/constants'

type PrimaryRailProps = {
  avatarUrl: string
  activeMenu: MenuKey
  isLoggedIn: boolean
  conversationUnreadCount: number
  onNavigate: (path: string) => void
}

type NavEntry = {
  key: MenuKey
  label: string
  path: string
  Icon: LucideIcon
  size?: number
}

const TOP_NAV: NavEntry[] = [
  { key: 'dashboard', label: '概览', path: '/dashboard', Icon: LayoutDashboard },
  { key: 'conversation', label: '聊天会话', path: '/conversation/realtime', Icon: MessageSquare },
  { key: 'message', label: '自动化', path: '/message/auto-reply', Icon: Bot },
  { key: 'contact', label: '好友管理', path: '/contact/address-book', Icon: User },
  { key: 'group', label: '群聊管理', path: '/group/welcome', Icon: Users },
]
export function PrimaryRail({
  avatarUrl,
  activeMenu,
  isLoggedIn,
  conversationUnreadCount,
  onNavigate,
}: PrimaryRailProps) {
  const visibleTopNav = isLoggedIn ? TOP_NAV : []
  return (
    <aside className="w-[60px] h-full bg-rail flex flex-col items-center py-6 text-railIcon shrink-0">
      <button
        type="button"
        className="mb-8 relative group"
        onClick={() => onNavigate('/dashboard')}
        title="控制台"
      >
        {isLoggedIn ? (
          <img
            src={avatarUrl}
            alt="profile"
            className="w-10 h-10 rounded border border-gray-600 group-hover:border-gray-400 bg-gray-700"
          />
        ) : (
          <span
            className="w-10 h-10 rounded border border-gray-600 group-hover:border-gray-400 bg-gray-700 flex items-center justify-center text-green-400"
            aria-hidden
          >
            <Bot size={22} />
          </span>
        )}
        {isLoggedIn ? (
          <span
            aria-hidden
            className="absolute top-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-rail"
          />
        ) : null}
      </button>

      <nav className="flex-1 w-full flex flex-col items-center gap-4">
        {visibleTopNav.map(({ key, label, path, Icon, size }) => {
          const active = activeMenu === key
          return (
            <button
              key={key}
              type="button"
              className={`w-full flex justify-center py-3 transition-colors ${
                active ? 'text-accent' : 'hover:text-gray-200'
              }`}
              onClick={() => onNavigate(path)}
              title={label}
              aria-label={label}
            >
              <span className="relative">
                <Icon size={size ?? 24} />
                {key === 'conversation' && conversationUnreadCount > 0 ? (
                  <span className="absolute -right-2 -top-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-[10px] leading-4 text-white">
                    {conversationUnreadCount > 99 ? '99+' : conversationUnreadCount}
                  </span>
                ) : null}
              </span>
            </button>
          )
        })}
      </nav>

    </aside>
  )
}
